import {Component, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatSlideToggle} from "@angular/material/slide-toggle";

import {MatInput} from "@angular/material/input";
import {IClientOptionsSettings} from "../../../models/client-options-settings.model";

@Component({
    selector: 'app-client-object-settings',
    templateUrl: './client-object-settings.component.html',
    imports: [
        MatFormField,
        MatSlideToggle,
        FormsModule,
        MatLabel,
        ReactiveFormsModule,
        MatInput,
        MatError
    ],
    styleUrls: ['./client-object-settings.component.scss']
})
export class ClientObjectSettings implements OnInit {
    private fb = inject(FormBuilder);

    @Input() clientSettingsForm: FormGroup;
    @Input() object: IClientOptionsSettings;

    ngOnInit(): void {
        this.clientSettingsForm.addControl('name', this.fb.control(this.object.name, Validators.required));
        this.clientSettingsForm.addControl('description', this.fb.control(this.object.description));
        this.clientSettingsForm.addControl('image', this.fb.control(this.object.image, Validators.pattern('https?://.+')));
        this.clientSettingsForm.addControl('enabled', this.fb.control(this.object.enabled));
    }
}
